import React from "react";

export default function AnalyticsSummary({
  totalDeliveries = 0,
  delivered = 0,
  notDelivered = 0,
  avgTime = "—",
  totalAmount = 0,
}) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(220px,1fr))",
        gap: "16px",
      }}
    >
      <Card icon="🚚" title="Всего доставок" value={totalDeliveries} note="за период" />
      <Card
        icon="✅"
        title="Доставлено"
        value={`${delivered} (${((delivered / (totalDeliveries || 1)) * 100).toFixed(1)}%)`}
        note="успешно"
      />
      <Card
        icon="⚠️"
        title="Не доставлено"
        value={notDelivered}
        note="по причинам"
      />
      <Card icon="⏱️" title="Среднее время" value={avgTime} note="на доставку" />
      <Card
        icon="💰"
        title="Оборот"
        value={`${Math.round(totalAmount).toLocaleString()} ₽`}
        note="всего"
      />
    </div>
  );
}

function Card({ icon, title, value, note }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "16px",
        textAlign: "center",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      <div style={{ fontSize: 22 }}>{icon}</div>
      <h3 style={{ margin: "8px 0 6px", fontSize: 16 }}>{title}</h3>
      <div style={{ fontSize: 24, fontWeight: 700 }}>{value}</div>
      <div style={{ color: "#666", fontSize: 12 }}>{note}</div>
    </div>
  );
}
